import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fileTypeService} from '_app/services';

import MediaPlayPrint from '_app/shared/components/MediaPlay/MediaPlayPrint';
import {Enums} from '_app/utils';
import MediaPlayVideo from '_app/shared/components/MediaPlay/MediaPlayVideo';
import PageHeader from '../shared/PageHeader/PageHeader';
import PageFooter from '../shared/PageFooter/PageFooter';
import {Disclaimer} from './components/Disclaimer/Disclaimer';
import {HtmlMediaContent} from './components/HtmlMediaContent/HtmlMediaContent';
import {fetchHtmlContent} from './components/HtmlMediaContent/htmlMediaContentActions';
import {mediaShape, publicOfficeInfoShape, publicUserInfoShape} from '_app/shapes';

export class MediaShare extends Component {
	componentDidMount() {
		const {media, fetchHtmlContent, office} = this.props;
		const isHtmlLandingPagesEnabled = office.data.landingPages;
		const htmlStoredFileID = media && media.HtmlStoredFileID;

		if (htmlStoredFileID && isHtmlLandingPagesEnabled){
			fetchHtmlContent(htmlStoredFileID);
		}
	}

	componentDidUpdate(prevProps) {
		const {media, fetchHtmlContent, office} = this.props;
		const isHtmlLandingPagesEnabled = office.data.landingPages;
		const htmlStoredFileID = media && media.HtmlStoredFileID;
		const prevHtmlStoredFileID = prevProps.media && prevProps.media.HtmlStoredFileID;

		if (isHtmlLandingPagesEnabled && htmlStoredFileID && prevHtmlStoredFileID !== htmlStoredFileID) {
			fetchHtmlContent(htmlStoredFileID);
		}
	}

	errorMessage() {
		return (
			<div className="error">
				<div><i className="fa fa-exclamation-triangle" /></div>
				{this.props.errorMessage}
			</div>
		);
	}

	isComplianceOrParentCompliance() {
		return (this.props.office.data.compliance || this.props.office.data.isComplianceParent);
	}

	pageContent() {
		let content = null;
		const {office, review, userInfo, source, token, media, errorMessage, isLoading, tracks, htmlContent} = this.props;
		const htmlStoredFileID = media && media.HtmlStoredFileID;
		const officeData = office && office.data;
		const classes = Enums.getType('mediaClass');
		const clazz = media && fileTypeService.classFromType(parseInt(media.Type));
		let versionDisclaimer;
		let complianceID;
		let advisorDisclaimer;
		let officeFooter;

		if (!isLoading && !errorMessage && (!htmlStoredFileID || !officeData.landingPages || (htmlContent.isLoading === false && !htmlContent.errorInfo)) ) {
			if (this.isComplianceOrParentCompliance()) {
				if (office.data.disclaimer) {
					({officeFooter} = userInfo);
					advisorDisclaimer = office.data.disclaimer;
				} else if (!office.data.disclaimer && (userInfo.officeFooter || userInfo.advisorDisclaimer) && !userInfo.partnerFooter) {
					({advisorDisclaimer, complianceID, officeFooter} = userInfo);
				} else if (!office.data.disclaimer && userInfo.partnerFooter) {
					advisorDisclaimer = userInfo.partnerFooter;
					({complianceID, officeFooter} = userInfo);
				}
				({disclaimer: versionDisclaimer, complianceID} = review);
			} else {
				({advisorDisclaimer, complianceID,officeFooter} = userInfo);
			}

			if (clazz === classes.VIDEO) {
				const sourceLink = Object.keys(source).length
					? fileTypeService.storedFileUrl(source.fileName)
					: null;

				content = (
					<MediaPlayVideo
						media={media}
						sourceLink={sourceLink}
						trackList={tracks}
						token={token}
						showDisclaimer
						userInfo={userInfo}
					/>
				);
			} else if ((clazz === classes.PRINT) || (clazz === classes.NEWSLETTER)) {
				content = htmlContent.content ?
					<HtmlMediaContent
						content={htmlContent.content}
					/> :
					<MediaPlayPrint
						media={media}
						token={token}
						showShare={false}
						userInfo={userInfo}
						office={officeData}
					/>;
			}
		}

		return (
			<div className="margin-bottom-lg">
				<div className="container">
					<div className="media-play-content">
						<div className="media-player-container">
							{(errorMessage || htmlContent.errorInfo) &&
							this.errorMessage()
							}
							{content}
							<Disclaimer
								officeFooter={officeFooter}
								advisorDisclaimer={advisorDisclaimer}
								versionDisclaimer={versionDisclaimer}
								complianceID={complianceID}
								isVideo={clazz === classes.VIDEO}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div className="use-sticky-footer media-share-page">
				<div className="with-stickyfooter hero-well bg-color-theme-secondary">
					<PageHeader logoUrl={this.props.userInfo.logoUrl} />
					{this.pageContent()}
				</div>
				{!this.props.office.isLoading && (
					<PageFooter
						userInfo={this.props.userInfo}
						office={this.props.office.data}
						token={this.props.token}
					/>
				)}
			</div>
		);
	}
}

MediaShare.propTypes = {
	media: mediaShape,
	userInfo: publicUserInfoShape,
	office: PropTypes.shape({
		isLoading: PropTypes.bool,
		data: publicOfficeInfoShape
	}).isRequired,
	errorMessage: PropTypes.string,
	isLoading: PropTypes.bool,
	review: PropTypes.object,
	source: PropTypes.object,
	tracks: PropTypes.array,
	token: PropTypes.string.isRequired
};

const mapStateToProps = ({htmlContent}) => ({
	htmlContent
});
const mapDispatchToProps = {
	fetchHtmlContent
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaShare);